define(["exports", "text!../../assets/algorithms.css"], function (_exports, _algorithms) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.run = run;
  _exports.name = void 0;
  _algorithms = _interopRequireDefault(_algorithms);

  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

  // @ts-check

  /**
  Currently used only for adding 'assert' class to algorithm lists
  */
  const name = "core/algorithms";
  _exports.name = name;

  async function run() {
    const elements = Array.from(document.querySelectorAll("ol.algorithm li"));
    elements.filter(li => li.textContent.trim().startsWith("Assert: ")).forEach(li => li.classList.add("assert"));

    if (document.querySelector(".assert")) {
      const style = document.createElement("style");
      style.textContent = _algorithms.default;
      document.head.appendChild(style);
    }
  }
});
//# sourceMappingURL=algorithms.js.map